export enum PRODUCT_FAMILY_CODES {
  HOMEDECOR = 'homedecor',
  PRINT = 'print',
}

export enum GROUP_CODES {
  PRINT_CLASSIC = 'print_classic',
  PRINT_CLASSIC_BORDER = 'print_classic_with_border',
  POSTER = 'poster',
  PRINT_VINTAGE = 'print_vintage',
  PRINT_PRO = 'print_pro',
  POSTER_PRO = 'poster_pro',
  HAPPY_CASE_CLASSIC = 'happy_case_classic',
  HAPPY_CASE_VINTAGE = 'happy_case_vintage',
  FOTOKIT_HOMEDECOR = 'fotokit_homedecor',
  FOTOKIT_MINISCRAP = 'fotokit_miniscrap',
}
